import {extend} from "vee-validate";
import { alpha_spaces, required, email, numeric, length } from 'vee-validate/dist/rules';

extend('alpha_spaces', alpha_spaces);
extend('required', required);
extend('email', email);
extend('numeric', numeric);
extend('length', length);
